exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// d:/Vagrant/apache_vm/edu/wp-content/themes/portaledu-escolas/node_modules/core-js/modules/_object-pie.js
// module id = 48
// module chunks = 0